export function reduce(state = 0) {
    return state + 1;
}

